import { render, staticRenderFns } from "./check-pending.vue?vue&type=template&id=97b7d1c0&scoped=true&"
import script from "./check-pending.vue?vue&type=script&lang=js&"
export * from "./check-pending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b7d1c0",
  null
  
)

export default component.exports